import React from 'react';

import { Paper, Grid, Typography } from '@material-ui/core';
import Input from 'components/Input';
import CEP from 'components/CEP';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faCarSide, faSprayCanSparkles } from '@fortawesome/free-solid-svg-icons';

import { useScreenMeasure } from 'helpers/hooks/useScreenMeasure';

export default function BusinessInfo({ formikProps }) {
  const [isMobile] = useScreenMeasure();

  const { values, errors, handleChange, setFieldValue } = formikProps;

  return(
    <Paper style={{ padding: '0 20px', marginBottom: 30 }}>
      <Grid container>
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <Typography variant='h6'>
            <b>Preencha as informações básicas do negócio</b>
          </Typography>
        </Grid>
      </Grid>
      <Grid container justify='flex-start' alignItems='center' style={{ gap: 10, padding: 15, marginTop: 20, backgroundColor: '#fef7d4', border: '2px solid #f2e1ab', borderRadius: 8 }}>
        <FontAwesomeIcon
          size='lg'
          color='#927959'
          icon={faTriangleExclamation}
        />
        <Typography variant='subtitle2' style={{ color: '#927959' }}>
          <b>Confira os dados com atenção. O novo estabelecimento será criado desativado e dependerá da liberação da equipe financeira.</b>
        </Typography>
      </Grid>
      <Grid container spacing={2} style={{ marginBottom: 10 }}>
        <Grid item xs={12} style={{ marginTop: 10 }}>
          <Typography variant='subtitle2' color='textSecondary'>
            Tipo de negócio (pode selecionar os dois)
          </Typography>
        </Grid>
        <Grid item md={6} xs={12}>
          <div
            style={{
              display: 'flex',
              gap: 20,
              border: values?.establishmentTypes?.includes(1) ? '2px solid #4fa15b' : '2px solid #cfcfcf',
              borderRadius: 8,
              cursor: 'pointer',
              padding: 20,
              backgroundColor: values?.establishmentTypes?.includes(1) ? 'rgba(79, 161, 91, 0.2)' : 'inherit'
            }}
            onClick={() => {
              let types = values?.establishmentTypes?.includes(1)
                ? values?.establishmentTypes?.filter(type => +type != 1)
                : [...values?.establishmentTypes, 1];

              setFieldValue('establishmentTypes', types);
            }}
          >
            <div style={{
              height: 50,
              width: 50,
              backgroundColor: values?.establishmentTypes?.includes(1) ? '#4fa15b' : '#cfcfcf',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 8
            }}>
              <FontAwesomeIcon
                size='lg'
                color='#FFFFFF'
                icon={faCarSide}
              />
            </div>
            <div>
              <Typography>
                <b>Estacionamento</b>
              </Typography>
              <Typography variant='subtitle2' color='textSecondary'>
                Controle do pátio, entradas e saídas.
              </Typography>
            </div>
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div
            style={{
              display: 'flex',
              gap: 20,
              border: values?.establishmentTypes?.includes(2) ? '2px solid #4fa15b' : '2px solid #cfcfcf',
              borderRadius: 8,
              cursor: 'pointer',
              padding: 20,
              backgroundColor: values?.establishmentTypes?.includes(2) ? 'rgba(79, 161, 91, 0.2)' : 'inherit'
            }}
            onClick={() => {
              let types = values?.establishmentTypes?.includes(2)
                ? values?.establishmentTypes?.filter(type => +type != 2)
                : [...values?.establishmentTypes, 2];

              setFieldValue('establishmentTypes', types);
            }}
          >
            <div style={{
              height: 50,
              width: 50,
              backgroundColor: values?.establishmentTypes?.includes(2) ? '#4fa15b' : '#cfcfcf',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 8
            }}>
              <FontAwesomeIcon
                size='lg'
                color='#FFFFFF'
                icon={faSprayCanSparkles}
              />
            </div>
            <div>
              <Typography>
                <b>Estética Automotiva</b>
              </Typography>
              <Typography variant='subtitle2' color='textSecondary'>
                Serviços de lavagem e estética.
              </Typography>
            </div>
          </div>
        </Grid>
        {!!errors.establishmentTypes && (
          <Grid item xs={12}>
            <Typography color='error'>
              {errors.establishmentTypes}
            </Typography>
          </Grid>
        )}
      </Grid>
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            Nome do estabelecimento
          </Typography>
          <Input
            autoFocus={!isMobile}
            name="establishmentName"
            label="Nome do estabelecimento"
            value={values.establishmentName}
            error={errors.establishmentName}
            helperText={errors.establishmentName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            CNPJ (Opcional)
          </Typography>
          <Input
            name="documentId"
            type="document"
            label="CNPJ (Opcional)"
            placeholder="00.000.000/0000-00"
            value={values.documentId}
            error={errors.documentId}
            helperText={errors.documentId}
            onChange={handleChange}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            Telefone
          </Typography>
          <Input
            noAutoComplete
            name="phone"
            type="phone"
            label="Telefone"
            placeholder="(00) 00000-0000"
            value={values.phone}
            error={errors.phone}
            helperText={errors.phone}
            onChange={handleChange}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            E-mail
          </Typography>
          <Input
            name="email"
            type="email"
            label="Email"
            placeholder="usuario@exemplo.com.br"
            value={values.email}
            error={errors.email}
            helperText={errors.email}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item md={4} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            CEP
          </Typography>
          <CEP
            name="postalCode"
            type="postalCode"
            label="CEP"
            value={values.postalCode}
            error={errors.postalCode}
            helperText={errors.postalCode}
            onChange={postalCode => {
              if (!postalCode.erro) {
                const { cep, logradouro, complemento, bairro, localidade, uf } = postalCode;

                setFieldValue('postalCode', cep);
                setFieldValue('street', logradouro);
                setFieldValue('complement', !complemento ? values.complement : complemento);
                setFieldValue('district', bairro);
                setFieldValue('city', localidade);
                setFieldValue('state', uf);
              }
            }}
          />
        </Grid>
        <Grid item md={8} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            Endereço
          </Typography>
          <Input
            name="street"
            type="text"
            label="Endereço"
            placeholder="Endereço"
            maxLength={255}
            value={values.street}
            error={errors.street}
            helperText={errors.street}
            onChange={handleChange}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            Número
          </Typography>
          <Input
            name="number"
            type="number"
            label="Número"
            placeholder="0"
            maxLength={8}
            value={values.number}
            error={errors.number}
            helperText={errors.number}
            onChange={handleChange}
          />
        </Grid>
        <Grid item md={8} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            Complemento (opcional)
          </Typography>
          <Input
            name="complement"
            type="text"
            label="Complemento"
            placeholder="Ex.: 3˚ andar"
            maxLength={50}
            value={values.complement}
            error={errors.complement}
            helperText={errors.complement}
            onChange={handleChange}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            Bairro
          </Typography>
          <Input
            name="district"
            type="text"
            label="Bairro"
            placeholder="Bairro"
            maxLength={50}
            value={values.district}
            error={errors.district}
            helperText={errors.district}
            onChange={handleChange}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            Cidade
          </Typography>
          <Input
            name="city"
            type="text"
            label="Cidade"
            placeholder="Cidade"
            maxLength={50}
            value={values.city}
            error={errors.city}
            helperText={errors.city}
            onChange={handleChange}
          />
        </Grid>
        <Grid item sm={2} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            UF
          </Typography>
          <Input
            name="state"
            type="text"
            label="UF"
            placeholder="UF"
            maxLength={2}
            value={values.state}
            error={errors.state}
            helperText={errors.state}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <Typography variant='subtitle2' color='textSecondary'>
            Total de ocupação do pátio
          </Typography>
          <Input
            name="vacanciesMarks"
            type="number"
            label="Total de ocupação do pátio"
            placeholder="0"
            maxLength={6}
            value={values.vacanciesMarks}
            error={errors.vacanciesMarks}
            helperText={errors.vacanciesMarks}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}